<div fxLayout="row" telemetry="DateTime picker">
    <div fxLayout="column">
        <forge-date-picker [attr.min]="minDate" [attr.max]="maxDate" show-today class="tt-margin--right">
            <forge-text-field #pickerTextField [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}"
                              [density]="Density" [attr.label-position]="LabelPosition" [attr.shape]="forCellEdit ? 'squared' : null">
                <input #input id="txt_date_{{Name}}" type="text" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit"
                       [disabled]="isViewOnly" [required]="isRequired" [(ngModel)]="dateValue"
                       (blur)="fireValueChanged()" (input)="onInputChange($event)" [attr.telemetry]="telemeteryName"
                       [name]="Name" (keydown)="onKeyDown($event)">
                <label for="txt_date_{{Name}}">{{DateLabel}}</label>
                <span *ngIf="hint && !dense && !compact" slot="support-text">{{hint}}</span>
                <span *ngIf="error && !dense && !compact" slot="support-text" class="error-red">{{error}}</span>
                <forge-circular-progress *ngIf="showSpinner" class="metadata-input--spinner" slot="end">
                </forge-circular-progress>
            </forge-text-field>
        </forge-date-picker>
    </div>

    <div fxLayout="column">
        <forge-time-picker step="10" [disabled]="isViewOnly" [attr.allow-seconds]="allowSeconds">
            <forge-text-field [density]="Density" [attr.label-position]="LabelPosition" [attr.shape]="forCellEdit ? 'squared' : null"
                              [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}">
                <input id="txt_time_{{Name}}" type="text" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit"
                       [(ngModel)]="timeValue" [disabled]="isViewOnly" [required]="isRequired"
                       (blur)="fireValueChanged()" (input)="onInputChange($event)" [attr.telemetry]="timeTelemeteryName"
                       name="{{Name}}.time" placeholder="hh:mm AM" (keydown)="onKeyDown($event)">
                <label for="txt_time_{{Name}}">{{TimeLabel}}</label>
                <span *ngIf="hint && !dense && !compact" slot="support-text">{{hint}}</span>
                <span *ngIf="error && !dense && !compact" slot="support-text" class="error-red">{{error}}</span>
                <forge-circular-progress *ngIf="showSpinner" class="metadata-input--spinner" slot="end">
                </forge-circular-progress>
            </forge-text-field>
        </forge-time-picker>
    </div>
</div>
